export const CreateSearchFloatPopup = false;
export const ShowTitleInPrevNext = false;
export const AllowConfirmationOfCodes = false;
export const EnableGroupView = true;// Allow confirmation of codes in the DocumentToolsCodes component, otherwise just permits denying the predictions

export const EDITABLE_DOCUMENT_METADATA = false;

export const UPLOAD_INSTRUCTIONS = true;




// WATCH LIST HIGHLIGHTING
export const TEMPORARY_WATCH_PHRASE_HIGHLIGHTING = false;
export const PERSISTENT_WATCH_PHRASE_HIGHLIGHTING = false;

// ENTITY TAGS - Create/display entity tags from document summaries (persons, entities, events)
export const ENABLE_ENTITY_TAGS = true;

// MAINTENANCE MODE — set to true while the backend infra is paused (see infra/scripts/pause.sh).
// Landing-page CTAs open a "we're under maintenance, email us" notice instead of
// the app, and every /app/* route renders the maintenance page without touching
// the API. Flip via REACT_APP_MAINTENANCE_MODE=false on Vercel (or edit here).
export const MAINTENANCE_MODE = (process.env.REACT_APP_MAINTENANCE_MODE ?? "false") === "true";
export const MAINTENANCE_CONTACT_EMAIL = "ceyer@loa-ai.com";
